import { Box, Button, Chip, Container, FormControl, InputAdornment, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import Apercu from './Apercu';
import { useDispatch } from 'react-redux';
import { ajoutsuccess,showapercu } from "./FactureSlice";
export default function NouvelleFacture() {
    const userData = useSelector(state => state.userData);
    const id = userData.id;
    const apitoken = userData.apitoken;
    const apiUrl = process.env.REACT_APP_API_URL;

    const facturesData = useSelector(state => state.facturesData);
    const ListClient = facturesData.listclients;

    const dispatch= useDispatch();

    const handleClientChange = (event) => {
      setvalClients(event.target.value);
      };
      const handleFactureChange = (event) => {
        setLastFacture(event.target.value);
        };

      const handleReglementChange = (event) => {
        setModeRegelement(event.target.value);
        };
    const [Progession, setProgession] = useState(false);
    const [Chargement, setChargement] = useState(false);
    const [rechercheInput,setRchercheInput] = useState('');
    const [valMarque, setMarque] = useState('Tout');
    const [valCategorie, setCategorie] = useState('Tout');
    const [listMarque,setListMarque] = useState([]);
    const [listCat,setListCat] = useState([]);
    const [listProduits, setListProduits] = useState([]);
    const [valClients, setvalClients] = useState('');
    const [LastFacture,setLastFacture] = useState('');
    const [modeRegelement, setModeRegelement] = useState('Espèce');
  
    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };
  
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;
  
    const [selectedDate, setSelectedDate] = useState(todayDate);

    const navigate = useNavigate();

    const clientField = useRef('')
    const numeroField = useRef('')
    const dateField = useRef('')
    const rechercheField = useRef('')
    const modeReglementField = useRef('')
    let listAchats=useRef([]);
  
    const formatDateToIso = (dateString) => {
      const formattedDate = new Date(`${dateString}T00:00:00Z`);
      const hours = new Date().getHours();
      const minutes = new Date().getMinutes();
      formattedDate.setHours(hours, minutes);
      return formattedDate.toISOString();
      };

      const removeZeroStock = (list) => {
        return list.current.filter(item => item.totalunite !== 0);
      };

      const calculateSum = (products) => {
        return products.reduce((total, product) => {
            if(product.stock === 0) {
                product.stock = 0
            }
            const tvaAmount = product.prix_vente * 0.2;
            return total + ((product.prix_vente + tvaAmount) * product.totalunite);
        
        }, 0);
    };

    const ShowApercu =() =>{
        dispatch(showapercu(true))
   }

   const formatDateToFrench = (dateString) => {
    const [date] = dateString.split('T');
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

        const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));


  const Recherche=(event) =>{
    const recherche=rechercheField.current.value
    if(recherche!==rechercheInput){
      setRchercheInput(recherche)
       }
  }

  const handleMarqueChange = (event) => {
    setMarque(event.target.value);
  };

  const handleCategorieChange = (event) => {
    setCategorie(event.target.value);
  }

    const getMarque=async () => {
        try {
        const response = await axios.post(`${apiUrl}marques/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListMarque(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }
    const getCategorie=async () => {
        try {
        const response = await axios.post(`${apiUrl}categories/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListCat(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }

    const getProduits=async () => {
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}produits/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        const data = response.data.map(product => ({
          ...product,pack:0,unite: 0,totalunite : 0
        }));
        setListProduits(data);
        }
     catch (error) {
      navigate('/');    
    }
    setChargement(false);
    }

    const StockUpdate2 = (value,idprod,event) => {
      const qte = value
      const id = idprod

      const updatedListProduits = listProduits.map(product => {
          if (product._id === id) {
              product.unite = qte
              const _id=product._id
              const designation=product.designation
              const pack=product.pack
              let unite = product.unite
              const qte_pack = product.qte_pack
              const marque = product.marque["id"]
              const categorie = product.categorie["id"]
              const prix_vente = product.prix_vente
              const prix_achat = product.prix_achat
              let totalunite = (parseInt(product.pack) * parseInt(product.qte_pack)) + parseInt(product.unite)
              const valeurs={_id,designation,pack,unite,totalunite,qte_pack,marque,categorie,prix_vente,prix_achat}
              // Vérifier si l'_id existe déjà dans le tableau
              const existingProductIndex = listAchats.current.findIndex(item => item._id === _id);
              if (existingProductIndex !== -1) {
                  // Mettre à jour la valeur du stock et les unités
                  listAchats.current[existingProductIndex].unite = unite;
                  listAchats.current[existingProductIndex].totalunite = totalunite;
                } else {
                  // Ajouter le nouveau produit au tableau
                  listAchats.current.push({...valeurs});
                }
              return { listAchats };
          }
          return product;
      });
      
  };

  const StockUpdate3 = (value,idprod,event) => {
    const qte = value
    const id = idprod

    const updatedListProduits = listProduits.map(product => {
        if (product._id === id) {
            const _id=product._id
            const designation=product.designation
            const pack=product.pack
            const unite = product.unite
            const qte_pack = product.qte_pack
            const marque = product.marque["id"]
            const categorie = product.categorie["id"]
            const prix_vente = Number(qte)
            const prix_achat = product.prix_achat
            let totalunite = (parseInt(product.pack) * parseInt(product.qte_pack)) + parseInt(product.unite)
            const valeurs={_id,designation,pack,unite,totalunite,qte_pack,marque,categorie,prix_vente,prix_achat}
            // Vérifier si l'_id existe déjà dans le tableau
            const existingProductIndex = listAchats.current.findIndex(item => item._id === _id);
            if (existingProductIndex !== -1) {
                // Mettre à jour la valeur du stock et les unités
                listAchats.current[existingProductIndex].prix_vente = prix_vente;
              } else {
                // Ajouter le nouveau produit au tableau
                listAchats.current.push({...valeurs});
              }
            return { listAchats };
        }
        return product;
    });
    
};

    const StockUpdate = (value,idprod,event) => {
        const qte = value;
        const id = idprod;

        const updatedListProduits = listProduits.map(product => {
            if (product._id === id) {
                product.pack = qte
                const _id=product._id
                const designation=product.designation
                let pack=product.pack
                const unite = product.unite
                const qte_pack = product.qte_pack
                const marque = product.marque["id"]
                const categorie = product.categorie["id"]
                const prix_vente = product.prix_vente
                const prix_achat = product.prix_achat
                let totalunite = (parseInt(product.pack) * parseInt(product.qte_pack)) + parseInt(product.unite)
                const valeurs={_id,designation,pack,unite,totalunite,qte_pack,marque,categorie,prix_vente,prix_achat}
                // Vérifier si l'_id existe déjà dans le tableau
                const existingProductIndex = listAchats.current.findIndex(item => item._id === _id);
                if (existingProductIndex !== -1) {
                    // Mettre à jour la valeur du stock et les unités
                    listAchats.current[existingProductIndex].pack = pack;
                    listAchats.current[existingProductIndex].totalunite = totalunite;
                  } else {
                    // Ajouter le nouveau produit au tableau
                    listAchats.current.push({...valeurs});
                  }
                return { listAchats };

           }
            return product;
        });
        
    };

    function ShowList() {
        if(listProduits.length > 0){
            let listFiltre=listProduits
            if(rechercheInput.length > 2) {
                listFiltre = listFiltre.filter(produit => produit.designation.toLowerCase().includes(rechercheInput.toLowerCase()))
            }
            if(valMarque!=="Tout") {
                listFiltre = listFiltre.filter(produit => produit.marque["id"] === valMarque)
            }
      
            if(valCategorie!=="Tout") {
              listFiltre = listFiltre.filter(produit => produit.categorie["id"] === valCategorie)
          }
        return listFiltre.map(Produit => {
            const currentQte = listAchats.current.find(item => item._id === Produit._id);
            let stock="0";
            let unite="0";
            let prix_vente=Produit.prix_vente
            if(currentQte){
                stock=currentQte.pack;
                unite=currentQte.unite;
                prix_vente=currentQte.prix_vente
            }

            return(
            
            <StyledTableRow key={Produit._id}>
            <StyledTableCell component="th" scope="row">
              {Produit.designation}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row">
            <TextField
       onChange={(event) => StockUpdate(event.target.value,Produit._id,event)}
        defaultValue={stock}
        id={Produit._id}
        label="Packs"
        size='normal'
        type='number'
        variant="outlined"
      />
            </StyledTableCell>
            <StyledTableCell component="th" scope="row">
            <TextField
        onChange={(event) => StockUpdate2(event.target.value,Produit._id,event)}
        defaultValue={unite}
        id={Produit._id}
        label="Unités"
        size='normal'
        type='number'
        variant="outlined"
      />
            </StyledTableCell>
            <StyledTableCell component="th" scope="row">
            <TextField
        onChange={(event) => StockUpdate3(event.target.value,Produit._id,event)}
        defaultValue={prix_vente}
        id={Produit._id}
        label="Prix"
        size='normal'
        type='number'
        variant="outlined"
      />
            </StyledTableCell>
            </StyledTableRow>
            )
            
        });
        
    }
    else{
        return <tr>
            <td colSpan={4} align='center'>Pas de données</td>
        </tr>;
    }
    
    }    

    const GetFacture = async (idfacture,date,facture) =>{
      try {
          const dateFr=formatDateToFrench(date)
          const response = await axios.get(`${apiUrl}generer/facture/${id}/${apitoken}/${idfacture}`,{
            responseType: 'blob',
          });
          // Créez un lien pour télécharger le PDF
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',`Facture N° ${facture} du ${dateFr}.pdf`);
          document.body.appendChild(link);
          link.click();
      }
          catch (error) {
              console.error('Error generating fsortie:', error);
            }
  }

    const Ajouter = async () => {

      const idclient=clientField.current.value
      if(idclient==="")
      {
        alert("veillez sélectionner un client")
        return
      }
      let client = ListClient.find(item => item._id === idclient);
      client={
          "id" : client._id,
          "nom" : client.nom,
          "prenom" : client.prenom,
          "ice" : client.ice,
          "ville" : client.ville,
          "client_code" : client.client_code,
      };

      const facture = numeroField.current.value
      if(facture ===0 || facture ==="")
      {
        alert("Numéro de facture incorrect");
        return
      }
      const reglement = modeReglementField.current.value
      const date = formatDateToIso(dateField.current.value)
      const total=calculateSum(listAchats.current)
      const produits = removeZeroStock(listAchats)
      const ventes = []
      const type = "vierge"
      setProgession(true);
      try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}new/facture/${id}/${apitoken}`,
        {
              client,
              facture,
              reglement,
              total,
              date,
              produits,
              ventes,
              type
          },
          {
            timeout: 20000,
          }
        );
        if(response.data.status==="exist")
        {
          alert("Ce numéro de facture existe déjà");
        }
        else{
          GetFacture(response.data.id,date,facture)
          dispatch(ajoutsuccess(true));
          navigate('/home/factures', { replace: true });
        }
      }
   catch (error) {
    navigate('/'); 
  }
  setProgession(false);
  }    

  const getLastFacture = async () =>{
    try {
    const response = await axios.post(`${apiUrl}lastfacture/${id}`,
      {
        timeout: 20000,
      }
    );
    setLastFacture(response.data);
}
    
        catch (error) {
            console.error('Error:', error);
        }
}

    useEffect(() =>{
        getProduits();
        getMarque();
        getCategorie();
        getLastFacture()
        },[]);

  return (

    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
    <Typography variant="h4" align='center' color="primary">
        Nouvelle facture
        </Typography>

        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} />
         :
          
          <Box display="flex" width="100%" justifyContent={'center'} mt={5}>

            <FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Clients</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="vendeur"
          inputRef={clientField}
          value={valClients}
          label="Clients"
          onChange={handleClientChange}
        >
          {ListClient.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom} {item.prenom} / {item.client_code} / {item.secteur.designation}
         </MenuItem>
       ))}
          </Select>
          </FormControl>

          <TextField sx={{ marginLeft: 2 }}
            inputRef={numeroField}
            value={LastFacture}
            onChange={handleFactureChange}
            id="input-with-icon-textfield"
            label="N° Facture"
            size='normal'
            type='number'
        variant="outlined"
      />  

<FormControl sx={{ minWidth: 150,marginLeft: 2 }}>
          <InputLabel id="demo-simple-select-label">Mode règlement</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="vendeur"
          inputRef={modeReglementField}
          value={modeRegelement}
          label="Mode règlement"
          onChange={handleReglementChange}
        >
          <MenuItem value="Espèce">Espèce</MenuItem>
          <MenuItem value="Chèque">Chèque</MenuItem>
          <MenuItem value="Virement">Virement</MenuItem>

          </Select>
          </FormControl>


              <TextField sx={{ marginLeft: 2 }}
            inputRef={dateField}
            value={selectedDate}
            onChange={handleDateChange}
            id="input-with-icon-textfield"
            label="Date"
            size='normal'
            type='date'
        variant="outlined"
      />              
            
</Box> 
}
    <Typography variant="h4" align='center' color="primary" sx={{ marginTop: '40px' }}>
        Produits
        </Typography> 

        <Box display="flex" width="100%" mt={5}>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :
        <TextField
        onKeyUp={Recherche}
        inputRef={rechercheField}
        id="input-with-icon-textfield"
        label="Recherche"
        size='normal'
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
      
       }
<Box sx={{ marginLeft: 2 }}>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
         <FormControl sx={{ minWidth: 150 }}>
         <InputLabel id="demo-simple-select-label">Marque</InputLabel>
         <Select
         
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={valMarque}
         label="Marque"
         onChange={handleMarqueChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
         {listMarque.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
         </Select>
         </FormControl>
}
</Box>
<Box sx={{ marginLeft: 2 }}>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Catégorie</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valCategorie}
          label="Catégorie"
          onChange={handleCategorieChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {listCat.map((item) => (
          <MenuItem key={item._id} value={item._id}>
            {item.designation}
          </MenuItem>
        ))}
          </Select>
          </FormControl>
}
</Box>
        </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Désignation</StyledTableCell>
            <StyledTableCell>Pack(s)</StyledTableCell>
            <StyledTableCell>Unité(s)</StyledTableCell>
            <StyledTableCell>Prix U HT</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}
<Box display="flex" width="100%" mt={2}>
<Box style={{ marginLeft: 'auto' }}>

{Chargement ? 
<Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
:

<Button sx={{ marginRight: '20px' }} variant="contained" size='large' color="primary" startIcon={<RemoveRedEyeOutlinedIcon/>} onClick={ShowApercu} >
Aperçu
</Button>  
} 
{Chargement ? 
<Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
:

<Button variant="contained" disabled={Progession} size='large' color="success" startIcon={<CloudDoneOutlinedIcon/>} onClick={Ajouter} >
Enregistrer
</Button>
} 
</Box>
</Box>
<Apercu Chargements={listAchats} Total={calculateSum(listAchats.current)} />
    </Container>
  )
}
